import React, { useCallback, useEffect } from "react";
import { Navigate, useNavigate, useParams, useSearchParams } from "react-router-dom";
import weui from "weui.js";
import { easService } from "../../services";
import { urls } from "../../urls";
import { getAxiosError } from "../../utils";

export const PowerLimitUserBinding = props => {
  const navigate = useNavigate(),
    { corpId } = useParams(),
    [qs] = useSearchParams(),
    ts = qs.get("ts"),
    sign = qs.get("sign"),
    infoMsg = "<br/><br/>提示: 点击确认后将跳转首页, 请忽略绑定提示, 直接退回微信即可.";

  const bindingUser = useCallback(async () => {
    const ld = weui.loading("订阅中...");
    try {
      const res = await easService.bindingPowerLimit(corpId, ts, sign);
      weui.alert(`您已成功订阅【${res.data}】的功率超限推送提醒.${infoMsg}`, () => navigate(urls.home()), { title: "订阅成功" });
    } catch (err) {
      weui.alert(`${getAxiosError(err)}${infoMsg}`, () => navigate(urls.home()), { title: "订阅失败" });
    } finally {
      ld.hide();
    }
  }, [corpId, ts, sign, navigate]);

  useEffect(() => {
    bindingUser();
  }, [bindingUser]);

  return (
    <>
      { !corpId && <Navigate to={ urls.home() } replace={ true } /> }
    </>
  );
};
